import BaseService from '@/services/BaseService';

class MemberService extends BaseService {
    viewMember = (id) => this.get(`/view-member/${id}`);

    createMember = (data) => this.post('/create-member', data);

    getMemberList = (data) => this.post(
        `/get-member-list?page=${data.page}&per_page=${data.per_page}`,
        data || {},
    );

    updateMember = (data, id) => this.post(`/edit-member/${id}`, data);

    changeMemberStatus = (data) => this.post('/update-member-status', data);

    getRoleOptionList = () => this.get('/get-role-option-list');

    deleteMember = (id) => this.delete(`/delete-member/${id}`);
}

export default new MemberService();
